export default __webpack_public_path__ + "static/media/screen1.59dcaa60.svg";